import axios from "axios";

export default {
  name: "termin-release",
  state: {
    listsalesContract: Array,
    listterminsalesContract: [],
    information: [],
    document: [],
    newDocument: [],
    deletedDocument: [],
    manifest: [],
  },
  getters: {
    getterminsalesContract: state => {
        return state.listsalesContract;
    },
    getterminlistsalesContract: state => {
      return state.listterminsalesContract;
    },
    getDocumentTerminRelease: state => {
      return state.document
    },
    getNewDocumentTerminRelease: state => {
      return state.newDocument
    },
    getDeletedDocumentTerminRelease: state => {
      return state.deletedDocument
    },
    getManifestterminRelease: state => {
      return state.manifest
    },
  },
  mutations: {
    setListsalesContract: (state, payload) => {
      state.listsalesContract = payload
    },
    setListTerminsalesContract: (state, payload) => {
      state.listterminsalesContract = payload
    },
    setDocumentTerminRelease: (state, payload) => {
      state.document = [...state.document, payload]
    },
    setNewDocumentTerminRelease: (state, payload) => {
      state.newDocument = [...state.newDocument, payload]
    },
    setInitialDocumentTerminRelease: (state, payload) => {
      state.document = payload
    },
    removeDocumentTerminRelease: (state, payload) => {
      const source = [...state.document];
      const index = source.findIndex((data) => data.id === payload.id);

      if (source[index].nama_file) {
        state.deletedDocument.push(source[index])
      }

      source.splice(index, 1);
      state.document = source
    },
    removeNewDocumentTerminRelease: (state, payload) => {
      const source = [...state.newDocument];
      const index = source.findIndex((data) => data.id === payload.id);
      source.splice(index, 1);
      state.newDocument = source
    },
    resetStateTerminRelease: (state) => {
      state.listsalesContract = [];
      state.listterminsalesContract = [];
      state.document = [];
      state.deletedDocument = [];
      state.newDocument = [];
    },
    setRevisiTerminRelease: (state, payload) => {
      state.document = payload.document;
      state.listterminsalesContract = payload.detail_termin;
      state.information = payload.information;
    },
    setManifestterminRelease: (state, payload) => {
      state.manifest = payload
    },
  },
  actions: {
    getListsalesContract(store) {
      return new Promise((resolve, reject) => {
          axios({
              method: "get",
              url: process.env.VUE_APP_SERVICEURL + "termin/sales_contract",
              auth: {
                username: store.getters.getAuth.username,
                password: store.getters.getAuth.password,
              },
              params: {
                  tlc: store.getters.getAuth.username
              },
              headers: {
                  "X-API-KEY": store.getters.getAuth.apikey,
              },
          })
              .then((response) => {
                  store.commit("setListsalesContract", response.data.data);
                  resolve(response.data.data);
              })
              .catch((err) => {
                  reject(err);
              });
      });
    },
    getListTerminsalesContract(store,{sales_contract,id_termin_release}) {
      return new Promise((resolve, reject) => {
          axios({
              method: "get",
              url: process.env.VUE_APP_SERVICEURL + "termin/termin_sales_contract",
              auth: {
                username: store.getters.getAuth.username,
                password: store.getters.getAuth.password,
              },
              params: {
                sales_contract: sales_contract,
                id_termin_release: id_termin_release
              },
              headers: {
                  "X-API-KEY": store.getters.getAuth.apikey,
              },
          })
              .then((response) => {
                  store.commit("setListTerminsalesContract", response.data.data);
                  resolve(response.data.data);
              })
              .catch((err) => {
                  reject(err);
              });
      });
    },
    getterminRelease(store, { id,tab,jenis }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "termin",
          auth: {
            username: store.getters.getAuth.username,
            password: store.getters.getAuth.password,
          },
          params: { tlc:store.getters.getAuth.username },
          headers: {
            "X-API-KEY": store.getters.getAuth.apikey,
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    setreleaseTermin(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append("tlc", params.tlc);
        formData.append("id_sc_dtl_invoice", params.id_sc_dtl_invoice);

        params.document_description.forEach((item,index) => {
          formData.append("document_description[]", params.document_description[index]);
          formData.append("nama_document[]", params.nama_document[index]);
        });

        axios({
          method: "post",
          url: process.env.VUE_APP_SERVICEURL + "termin/releasetermin",
          data: formData,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getTerminFileSupport(store, { id_termin }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "termin/getdocumenttermin",
          params: { id_termin: id_termin},
          auth: {
            username: store.getters.getAuth.username,
            password: store.getters.getAuth.password,
          },
          headers: {
            "X-API-KEY": store.getters.getAuth.apikey,
          },
        })
          .then(({ data }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    setDocumentTerminRelease(store, payload) {
      store.commit('setDocumentTerminRelease', payload)
    },
    removeDocumentTerminRelease(store, payload) {
      store.commit('removeDocumentTerminRelease', payload)
    },
    resetStateTerminRelease(store) {
      store.commit("resetStateTerminRelease")
    },
    postTerminRelease(store, { mode, payload }) {
      console.log(payload)
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: process.env.VUE_APP_SERVICEURL + "termin" + (mode=="Edit" ? "/edit":""),
          data: payload,
          auth: {
            username: store.getters.getAuth.username,
            password: store.getters.getAuth.password,
          },
          headers: {
            "X-API-KEY": store.getters.getAuth.apikey,
            "Content-Type": "multipart/form-data",
          },
        })
          .then(({ data }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetchDataRevisiTerminRelease(store, { payload }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "termin/detail",
          params: { 
            id_termin_release: payload,
            tlc : store.getters.getAuth.username
          },
          auth: {
            username: store.getters.getAuth.username,
            password: store.getters.getAuth.password,
          },
          headers: {
            "X-API-KEY": store.getters.getAuth.apikey,
          },
        })
          .then(({ data }) => {
            store.commit('setRevisiTerminRelease', data)
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getManifestterminRelease(store, { params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "termin",
          auth: {
            username: store.getters.getAuth.username,
            password: store.getters.getAuth.password,
          },
          params: { 
            id_termin_release: params.id,
            tlc: store.getters.getAuth.username,
          },
          headers: {
            "X-API-KEY": store.getters.getAuth.apikey,
          },
        })
          .then((response) => {
            store.commit('setManifestterminRelease', response.data)
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
